import { Component, Input } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { Tier, allTiers } from 'app/my-account/plan-and-session/helpers/tiers';

@Component({
	selector: 'app-session-values',
	templateUrl: './session-values.component.html',
	styleUrls: ['./session-values.component.scss'],
})
export class SessionValuesComponent {
	tiers: Tier[] = allTiers;

	@Input() type: 'particular' | 'corporate' = 'particular';
	@Input() particularPrice = 0;
	@Input() corporateTiers: string[] = [];
	constructor(public translateService: TranslateService) {}

	get typeLabel(): string {
		if (this.type === 'particular') {
			return this.translateService.instant(
				'MY_ACCOUNT.SESSION_VALUES.PARTICULAR'
			);
		}
		return this.translateService.instant('MY_ACCOUNT.SESSION_VALUES.CORPORATE');
	}

	get corporatePrices(): string {
		return this.corporateTiers
			.map((tier) => {
				const foundTier = this.tiers.find((t) => t.id === tier);
				if (foundTier) {
					return `R$ ${foundTier.name}`;
				}
			})
			.join(' / ');
	}
}
